import { IconButton, Stack, SxProps, Typography } from "@mui/material";

// components
import Iconify from "./Iconify";

// ----------------------------------------------------------------------

type Props = {
	title: string;
	back?: boolean;
	onPressBack?: () => void;
	sx?: SxProps;
};

export default function PageHeader({ title, onPressBack, back = true, sx }: Props) {
	return (
		<header>
			<Stack alignItems='center' direction='row' gap={1} sx={{ mb: 1, ...sx }}>
				{back && (
					<IconButton onClick={onPressBack} sx={{ p: 0.8 }}>
						<Iconify height={20} icon={"eva:arrow-back-fill"} width={20} />
					</IconButton>
				)}
				<Typography variant='h4'>{title}</Typography>
			</Stack>
		</header>
	);
}
